import React, { createContext, useEffect, useState } from "react";

const RelatoriosContext = createContext();

const RelatoriosProvider = ({ children }) => {
  const initialColunas = [{ nome: "", variavel: "$C{}", script: "" }];
  const initialFiltros = [
    { nome: "", 
      variavel: "$F{}", 
      script: "", 
      tipoDado: null, 
      codCombo: null,
      codComboPai: null,
      nomeComboPai: null },
  ];
  const initialRelatorio = {
    nome: "",
    codigoRelatorio: "",
    script: "",
    tipoRelatorio: { id: null, nome: null },
    apuracao: false,
  };

  const [dadosColunas, setDadosColunas] = useState(initialColunas);
  const [dadosFiltros, setDadosFiltros] = useState(initialFiltros);
  const [dadosRelatorios, setDadosRelatorios] = useState(initialRelatorio);
  useEffect(() => {
    // console.clear()
  }, [dadosColunas, dadosFiltros, dadosRelatorios])
  const resetDados = () => {
    setDadosColunas(initialColunas);
    setDadosFiltros(initialFiltros);
    setDadosRelatorios(initialRelatorio);
  };

  return (
    <RelatoriosContext.Provider
      value={{
        dadosColunas,
        setDadosColunas,
        dadosFiltros,
        setDadosFiltros,
        dadosRelatorios,
        setDadosRelatorios,
        resetDados,
      }}
    >
      {children}
    </RelatoriosContext.Provider>
  );
};

export { RelatoriosContext, RelatoriosProvider };
